import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetDocumentDetailsPageRequirement } from "../../Documents/Details/useGetDocumentDetailsPageRequirement";
import { RESUME_REQUIREMENT_ID } from "../../PlacementCandidate/components/PlacementCandidateOnboarding/ResumeCard";
import { PlacementCandidateScreeningStatus } from "../../PlacementCandidate/types";
import { EmailUsResumeConfirmationDialog } from "./EmailUsResumeConfirmationDialog";
import { RecruiterAccessUnlockCard } from "./RecruiterAccessUnlockCard";
import { ShareYourResumeCard } from "./ShareYourResumeCard";

interface ResumeUploadProps {
  placementCandidateId: string;
  candidateScreeningStatus?: PlacementCandidateScreeningStatus;
  placementId: string;
  workplaceId: string;
}

export function ResumeUpload(props: ResumeUploadProps) {
  const { placementCandidateId, candidateScreeningStatus, placementId, workplaceId } = props;
  const worker = useDefinedWorker();
  const emailUsResumeConfirmationModalState = useModalState();

  const { requirement, isLoading } = useGetDocumentDetailsPageRequirement({
    requirementId: RESUME_REQUIREMENT_ID,
  });

  return !isLoading &&
    isDefined(requirement) &&
    [
      WorkerRequirementStatus.MISSING,
      WorkerRequirementStatus.EXPIRED,
      WorkerRequirementStatus.REJECTED,
    ].includes(requirement.status) ? (
    <>
      {candidateScreeningStatus === PlacementCandidateScreeningStatus.PASSED_EXCEPTIONALLY ? (
        <RecruiterAccessUnlockCard
          resumeRequirement={requirement}
          modalState={emailUsResumeConfirmationModalState}
          placementCandidateId={placementCandidateId}
          candidateScreeningStatus={candidateScreeningStatus}
          workplaceId={workplaceId}
          placementId={placementId}
          workerEmail={worker.email}
        />
      ) : (
        <ShareYourResumeCard
          resumeRequirement={requirement}
          modalState={emailUsResumeConfirmationModalState}
          placementCandidateId={placementCandidateId}
          candidateScreeningStatus={candidateScreeningStatus}
          workplaceId={workplaceId}
          placementId={placementId}
          workerEmail={worker.email}
        />
      )}
      <EmailUsResumeConfirmationDialog
        modalState={emailUsResumeConfirmationModalState}
        placementCandidateId={placementCandidateId}
        workplaceId={workplaceId}
        placementId={placementId}
        candidateScreeningStatus={candidateScreeningStatus}
        workerEmail={worker.email}
      />
    </>
  ) : undefined;
}
